import { css } from "@emotion/react";
import { useTheme } from "../theme";

export interface RowProps extends React.ComponentPropsWithoutRef<"div"> {
  /**
   * align-itemsを指定します。
   *
   * @default streach
   */
  alignItems?: "streach" | "center" | "flex-end" | "flex-start";
  /**
   * justify-contentを指定します。
   *
   * @default flex-start
   */
  justify?:
    | "space-around"
    | "space-between"
    | "space-evenly"
    | "center"
    | "flex-end"
    | "flex-start";
  /**
   * 子要素と子要素の間隔を指定します。
   *
   * numberを指定した場合、marginはtheme.spacing * props.gapで計算されます。
   *
   * @default undefined
   */
  gap?: number;
  /**
   * nowrapを指定すると、子要素が改行しなくなります。
   *
   * @default false
   */
  nowrap?: boolean;
  direction?: "column" | "row";
}

/**
 * @deprecated 代わりにCSSを書いてください。
 */
export const Row = ({
  gap = 0,
  justify,
  alignItems = "streach",
  nowrap = false,
  direction = "row",
  ...props
}: RowProps) => {
  const theme = useTheme();
  return (
    <div
      css={css`
        box-sizing: border-box;
        display: flex;
        flex-direction: ${direction === "column" ? "column" : "row"};
        flex-wrap: ${nowrap ? "nowrap" : "wrap"};
        gap: ${theme.spacing * gap}px;
        align-items: ${alignItems};
        justify-content: ${justify};
        width: 100%;
      `}
      {...props}
    />
  );
};
